// React
import React from 'react'
// Data
import { aspects } from '../../data/aspects'
// Components
import Icon from '../Display/Icon'

export default class Compatibility extends React.Component {

	componentDidMount() {
		document.addEventListener('keydown', this.escFunction, false)
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.escFunction, false)
	}

	escFunction = (event) => {
		if(event.keyCode === 27) {
			this.removePage()
		}
	}

	removePage = () => {
		window.localStorage.removeItem('MoonSignApp:colorScale')
		if (this.props.state.nav.length > 1) {
			this.props.redux.nav.removePage()
		}
		else {
			this.props.redux.nav.setPage('relationships')
		}
	}

	render() {
		return (
			<div className='capps-fullscreen'>
				<div className='capps-close' onTouchTap={() => this.removePage()}>
					<span style={{ marginRight: '5px', marginBottom: '5px' }}>close</span> <Icon name='close-circle' />
				</div>
				<div className='capps-responsive'>
					{/* SCALE */}
					<div className='capps-header'>Color Scale</div>
					<div className='capps-height-20' />
					<div className='capps-scale-box'>
						<div className='capps-scale-aspects-box'>
							<span className='capps-scale-title'>aspect</span>
							<span className='capps-scale-aspect'>conjunction</span>
							<span className='capps-scale-aspect'>trine</span>
							<span className='capps-scale-aspect'>sextile</span>
							<span className='capps-scale-aspect'>quincunx</span>
							<span className='capps-scale-aspect'>semi-sextile</span>
							<span className='capps-scale-aspect'>opposition</span>
							<span className='capps-scale-aspect'>square</span>
						</div>
						<div className='capps-scale' />
						<div className='capps-scale-text-box'>
							<span className='capps-scale-title'>quality</span>
							<span className='capps-scale-text'>{aspects['conjunction'].keyword}</span>
							<span className='capps-scale-text'>{aspects['trine'].keyword}</span>
							<span className='capps-scale-text'>{aspects['sextile'].keyword}</span>
							<span className='capps-scale-text'>{aspects['quincunx'].keyword}</span>
							<span className='capps-scale-text'>{aspects['semisextile'].keyword}</span>
							<span className='capps-scale-text'>{aspects['opposition'].keyword}</span>
							<span className='capps-scale-text'>{aspects['square'].keyword}</span>
						</div>
					</div>
					{/* ASPECTS */}
					<div className='capps-height-20' />
					<div className='capps-height-20' />
					<div className='capps-flex-horiz-left'>
						<div className='capps-contactinfo'><span className={'capps-compatibility ' + aspects['conjunction'].color} /></div>
						<div className='capps-text bold'>Conjunction</div><div className='capps-text' style={{ marginLeft: '15px' }}>{aspects['conjunction'].keyword}</div>
					</div>
					<div className='capps-height-10' />
					<div className='capps-form'>
						{aspects['conjunction'].description}
					</div>
					<div className='capps-height-20' />
					<div className='capps-height-20' />
					<div className='capps-flex-horiz-left'>
						<div className='capps-contactinfo'><span className={'capps-compatibility ' + aspects['trine'].color} /></div>
						<div className='capps-text bold'>Trine</div><div className='capps-text' style={{ marginLeft: '15px' }}>{aspects['trine'].keyword}</div>
					</div>
					<div className='capps-height-10' />
					<div className='capps-form'>
						{aspects['trine'].description}
					</div>
					<div className='capps-height-20' />
					<div className='capps-height-20' />
					<div className='capps-flex-horiz-left'>
						<div className='capps-contactinfo'><span className={'capps-compatibility ' + aspects['sextile'].color} /></div>
						<div className='capps-text bold'>Sextile</div><div className='capps-text' style={{ marginLeft: '15px' }}>{aspects['sextile'].keyword}</div>
					</div>
					<div className='capps-height-10' />
					<div className='capps-form'>
						{aspects['sextile'].description}
					</div>
					<div className='capps-height-20' />
					<div className='capps-height-20' />
					<div className='capps-flex-horiz-left'>
						<div className='capps-contactinfo'><span className={'capps-compatibility ' + aspects['quincunx'].color} /></div>
						<div className='capps-text bold'>Quincunx</div><div className='capps-text' style={{ marginLeft: '15px' }}>{aspects['quincunx'].keyword}</div>
					</div>
					<div className='capps-height-10' />
					<div className='capps-form'>
						{aspects['quincunx'].description}
					</div>
					<div className='capps-height-20' />
					<div className='capps-height-20' />
					<div className='capps-flex-horiz-left'>
						<div className='capps-contactinfo'><span className={'capps-compatibility ' + aspects['semisextile'].color} /></div>
						<div className='capps-text bold'>Semi-sextile</div><div className='capps-text' style={{ marginLeft: '15px' }}>{aspects['semisextile'].keyword}</div>
					</div>
					<div className='capps-height-10' />
					<div className='capps-form'>
						{aspects['semisextile'].description}
					</div>
					<div className='capps-height-20' />
					<div className='capps-height-20' />
					<div className='capps-flex-horiz-left'>
						<div className='capps-contactinfo'><span className={'capps-compatibility ' + aspects['opposition'].color} /></div>
						<div className='capps-text bold'>Opposition</div><div className='capps-text' style={{ marginLeft: '15px' }}>{aspects['opposition'].keyword}</div>
					</div>
					<div className='capps-height-10' />
					<div className='capps-form'>
						{aspects['opposition'].description}
					</div>
					<div className='capps-height-20' />
					<div className='capps-height-20' />
					<div className='capps-flex-horiz-left'>
						<div className='capps-contactinfo'><span className={'capps-compatibility ' + aspects['square'].color} /></div>
						<div className='capps-text bold'>Square</div><div className='capps-text' style={{ marginLeft: '15px' }}>{aspects['square'].keyword}</div>
					</div>
					<div className='capps-height-10' />
					<div className='capps-form'>
						{aspects['square'].description}
					</div>
					<div className='capps-height-10' />
					<div className='capps-footer' onTouchTap={() => {
						setTimeout(() => {
							window.localStorage.removeItem('MoonSignApp:colorScale')
							window.localStorage.setItem('MoonSignApp:compatibility', true)
							this.props.redux.nav.setPage('relationships')
						}, 20)
					}}>
						<span className='capps-link'>Read more</span>
					</div>
					<div className='capps-height-20' />
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Components/Pages/ColorScale.js